import { Icon, IconProps } from "..";

export const Shoes = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 56 56" {...props}>
      <>
        <path
          clipRule="evenodd"
          fillRule="evenodd"
          d="M20.8404 13.6387H17.9422V16.5082H15.0726V22.2473H12.2031V27.9865H9.3335V33.7543H15.0726V36.6239H20.8117V39.4934H26.5508V42.363H40.9274V39.4934H46.6668V33.7256H43.7973V30.856H38.0578V27.9865H35.1882V25.1169H32.3186V22.2473H29.4491V19.3778H23.71V16.5082H20.8404V13.6387ZM26.5795 22.2761V25.1169H29.4204V22.2761H26.5795ZM32.29 27.9865H29.4491V25.1456H32.29V27.9865ZM35.1595 30.856H32.3186V28.0152H35.1595V30.856ZM35.1882 33.7256H38.0291V30.8847H35.1882V33.7256Z"
          fill="currentColor"
        />
      </>
    </Icon>
  );
};
